import { AnyFilter } from '../types/filters';
import { AnyTimelineEventsFilter } from '../types/timelineEventsFilters';
import { PaginationBaseRequest } from './pagination';

export const UPDATE_FEATURE_ITEMS_FILTERS = 'UPDATE_FEATURE_ITEMS_FILTERS';
export const REMOVE_FEATURE_ITEMS_FILTER = 'REMOVE_FEATURE_ITEMS_FILTER';
export const UPDATE_SHOW_FIXES_ONLY = 'UPDATE_SHOW_FIXES_ONLY';
export const UPDATE_GROUP_WORK_ITEMS_BY_TICKET = 'UPDATE_GROUP_WORK_ITEMS_BY_TICKET';
export const PERFORM_FEATURE_ITEMS_SEARCH = 'PERFORM_FEATURE_ITEMS_SEARCH';
export const UPDATE_SHOW_AUTOMATIONS_TIMELINE_EVENTS_ONLY = 'UPDATE_SHOW_AUTOMATIONS_TIMELINE_EVENTS_ONLY';
export const UPDATE_TIMELINE_EVENTS_FILTERS = 'UPDATE_TIMELINE_EVENTS_FILTERS';
export const REMOVE_TIMELINE_EVENTS_FILTER = 'REMOVE_TIMELINE_EVENTS_FILTER';

export interface FilterFeatureItemsPayload {
    filters: AnyFilter[];
    appId: string;
}

export interface FilterTimelineEventsPayload extends PaginationBaseRequest {
    filters: AnyTimelineEventsFilter[];
}

// Actions

export interface UpdateFeatureItemsFiltersAction {
    type: typeof UPDATE_FEATURE_ITEMS_FILTERS;
    payload: FilterFeatureItemsPayload;
}

export interface RemoveFeatureItemsFilterPayload {
    filter: AnyFilter;
    appId: string;
}

export interface RemoveFeatureItemsFilterAction {
    type: typeof REMOVE_FEATURE_ITEMS_FILTER;
    payload: RemoveFeatureItemsFilterPayload;
}

export interface UpdateShowFixesOnlyPayload {
    showFixesOnly: boolean;
    appId: string;
}

export interface UpdateShowFixesOnlyAction {
    type: typeof UPDATE_SHOW_FIXES_ONLY;
    payload: UpdateShowFixesOnlyPayload;
}

export interface UpdateGroupWorkItemsByTicketPayload {
    groupByTicket: boolean;
    appId: string;
}

export interface UpdateGroupWorkItemsByTicketAction {
    type: typeof UPDATE_GROUP_WORK_ITEMS_BY_TICKET;
    payload: UpdateGroupWorkItemsByTicketPayload;
}

export interface UpdateFeatureItemsSearchAction {
    type: typeof PERFORM_FEATURE_ITEMS_SEARCH;
    payload: string;
}

export interface UpdateShowAutomationsTimelineEventsOnlyAction {
    type: typeof UPDATE_SHOW_AUTOMATIONS_TIMELINE_EVENTS_ONLY;
    payload: boolean;
}

export interface UpdateTimelineEventsFiltersAction {
    type: typeof UPDATE_TIMELINE_EVENTS_FILTERS;
    payload: FilterTimelineEventsPayload;
}

export interface RemoveTimelineEventsFilterAction {
    type: typeof REMOVE_TIMELINE_EVENTS_FILTER;
    payload: AnyTimelineEventsFilter;
}

// Action creators

export const updateFeatureItemsFilters: (payload: FilterFeatureItemsPayload) => UpdateFeatureItemsFiltersAction = (
    payload,
) => {
    return {
        type: UPDATE_FEATURE_ITEMS_FILTERS,
        payload,
    };
};

export const removeFeatureItemsFilter: (payload: RemoveFeatureItemsFilterPayload) => RemoveFeatureItemsFilterAction = (
    payload,
) => {
    return {
        type: REMOVE_FEATURE_ITEMS_FILTER,
        payload,
    };
};

export const updateShowFixesOnly: (payload: UpdateShowFixesOnlyPayload) => UpdateShowFixesOnlyAction = (payload) => {
    return {
        type: UPDATE_SHOW_FIXES_ONLY,
        payload,
    };
};

export const updateGroupWorkItemsByTicket: (
    payload: UpdateGroupWorkItemsByTicketPayload,
) => UpdateGroupWorkItemsByTicketAction = (payload) => {
    return {
        type: UPDATE_GROUP_WORK_ITEMS_BY_TICKET,
        payload,
    };
};

export const updateFeatureItemsSearch: (payload: string) => UpdateFeatureItemsSearchAction = (payload) => {
    return {
        type: PERFORM_FEATURE_ITEMS_SEARCH,
        payload,
    };
};

export const updateShowAutomationsTimelineEventsOnly: (
    payload: boolean,
) => UpdateShowAutomationsTimelineEventsOnlyAction = (payload) => {
    return {
        type: UPDATE_SHOW_AUTOMATIONS_TIMELINE_EVENTS_ONLY,
        payload,
    };
};

export const updateTimelineEventsFilters: (
    payload: FilterTimelineEventsPayload,
) => UpdateTimelineEventsFiltersAction = (payload) => {
    return {
        type: UPDATE_TIMELINE_EVENTS_FILTERS,
        payload,
    };
};

export const removeTimelineEventsFilter: (payload: AnyTimelineEventsFilter) => RemoveTimelineEventsFilterAction = (
    payload,
) => {
    return {
        type: REMOVE_TIMELINE_EVENTS_FILTER,
        payload,
    };
};
